import { SVGProps } from 'react';

const CircleParkingOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.656 7H13a3 3 0 0 1 2.984 3.307M13 13H9m10.071 6.07A10 10 0 1 1 4.93 4.93M2 2l20 20M8.357 2.687a10 10 0 0 1 12.956 12.956M9 17V9"
    />
  </svg>
);
export default CircleParkingOff;
